import { InstallationConfigDto, InstallationWizardCompletedStep } from '@/api/generator';

export interface CompletedEventArgs {
  shouldUpdate: boolean;
  preventNextNavigation?: boolean;
}

export type CompletedStep =
  (typeof InstallationWizardCompletedStep)[keyof typeof InstallationWizardCompletedStep];

export const completedStepsOrdered: Array<CompletedStep> = [
  'None',
  'Database',
  'SiteName',
  'Email',
  'User',
];

export interface InstallationStepDatabaseSettingsProps {
  defaultConnectionString: InstallationConfigDto['defaultConnectionString'];
  blobStoringConnectionString: InstallationConfigDto['blobStoringConnectionString'];
  integratedDefaultConnectionString: InstallationConfigDto['integratedDefaultConnectionString'];
  integratedBlobConnectionString: InstallationConfigDto['integratedBlobConnectionString'];
  isCustomDatabaseUsed: InstallationConfigDto['isCustomDatabaseUsed'];
  databaseJobIsRunning: boolean;
}

export type InstallationStepDatabaseSettingsEmits = ((
  evt: 'completed',
  args: CompletedEventArgs,
) => void) &
  ((evt: 'change', value: boolean) => void) &
  ((evt: 'update:databaseJobIsRunning', value: boolean) => void);
